<template>
  <div class="custom-tooltip" :class="{ 'custom-tooltip--small': small }">
    <PopoverModal
      v-model:shown="isVisible"
      :placement="placement"
      :distance="1"
      :show-close-button="showCloseButton"
    >
      <template #trigger>
        <button
          class="custom-tooltip__toggle"
          :class="computedToggleClass"
          :aria-label="label"
          :aria-expanded="isVisible"
          @keydown.tab.shift.exact="closeTooltip"
          @keydown.esc="onClickEsc"
        >
          <i class="icon icon-Info" aria-hidden="true"></i>
        </button>
      </template>
      <div class="custom-tooltip__content">
        <slot :close="closeTooltip" />
      </div>
    </PopoverModal>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import PopoverModal from '../PopoverModal/PopoverModal.vue';
import type { CustomTooltipProps } from './types';

const props = withDefaults(defineProps<CustomTooltipProps>(), {
  label: 'Toggle',
  placement: 'bottom-end',
  small: false,
  showCloseButton: false,
});

const isVisible = ref(false);

const computedToggleClass = computed(() => [
  isVisible.value && 'custom-tooltip__toggle--open',
  props.componentVariant,
]);

const onClickEsc = (e: KeyboardEvent) => {
  if (!isVisible.value) return;
  e.stopPropagation();
  closeTooltip();
};

const closeTooltip = () => {
  isVisible.value = false;
};
</script>

<style lang="scss">
@import './scss/CustomTooltip.scss';
</style>
